/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-custom-event-conversion-type',
  template: `<span *ngIf="conversionType">{{ ('customEvent.conversionType.' + conversionType) | ogTranslate }}</span>`
})
export class CustomEventConversionTypeLabelComponent {
  @Input() conversionType: string;
}
